var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"has-modal-card":"","trap-focus":"","full-screen":""},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},[_c('div',{staticClass:"modal-card w-100p"},[_c('FeaturesList',{attrs:{"title":"landing.our_offers","showSelect":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }